import styled from 'styled-components';

export const Overlay = styled.div<{ $isOpen: boolean }>`
    display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    align-items: center;
    justify-content: center;
    padding: 1rem;
`;

export const Card = styled.div`
    position: relative;
    background: #fff;
    border-radius: 10px;
    padding: 2rem 1.75rem 1.5rem;
    max-width: 540px;
    width: 100%;
    height: 280px;
    text-align: center;
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 1.15rem;
    right: 1.15rem;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    color: #888;
    font-size: 1.8rem;
    line-height: 1;

    &:hover {
        color: #222;
    }
`;

export const CloseLink = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    font-family: 'Segoe UI', sans-serif;
    font-size: 18px;
    font-weight: 500;
    color: #000;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;

export const ErrorMessage = styled.p`
    font-family: 'Segoe UI', sans-serif;
    font-size: 16px;
    color: #494949;
    line-height: 1.5;
    margin: 1rem;
    width: 100%;
    max-width: 480px;
    font-weight: 400;
`;
